/** @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/react'
import { View } from '@components/atoms'
import { OrderDetailType } from '@schemas'

interface OrderDetailProps {
	orderDetails: OrderDetailType[]
}

export const OrderDetail: React.FC<OrderDetailProps> = ({ orderDetails }) => {
	return (
		<View css={styles.container}>
			{orderDetails.map((detail, index) => (
				<View key={index} css={styles.detailItem}>
					<View css={styles.productInfo}>
						<View css={styles.numberCircle}>{index + 1}</View>
						<View css={styles.productDetails}>
							<span css={styles.productName}>{detail.productName}</span>
							<span css={styles.productSubInfo}>{detail.id}</span>
						</View>
					</View>
					<View css={styles.priceInfo}>
						<View css={styles.priceRow}>
							<span css={styles.label}>판매수량:</span>
							<span css={styles.value}>{detail.quantity} 개</span>
						</View>
						<View css={styles.priceRow}>
							<span css={styles.label}>판매가격:</span>
							<span css={styles.value}>${detail.soldUsd.toFixed(2)}</span>
						</View>
						<View css={styles.priceRow}>
							<span css={styles.label}>시즌가격:</span>
							<span css={styles.value}>${detail.seasonUsd.toFixed(2)}</span>
						</View>
						<View css={styles.priceRow}>
							<span css={styles.label}>할인가격:</span>
							<span css={styles.value}>${detail.seasonDiscountedUsd.toFixed(2)}</span>
						</View>
					</View>
				</View>
			))}
		</View>
	)
}

const styles = {
	container: css`
		width: 100%;
		min-width: 48rem;
		display: flex;
		flex-direction: column;
		gap: 1rem;
	`,
	detailItem: css`
		display: flex;
		justify-content: space-between;
		padding: 1rem;
		background-color: white;
		border-radius: 0.5rem;
		border: 1px solid #e5e7eb;
	`,
	productInfo: css`
		display: flex;
		align-items: center;
		gap: 1rem;
	`,
	numberCircle: css`
		width: 2rem;
		height: 2rem;
		background-color: #2563eb;
		color: white;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 600;
	`,
	productDetails: css`
		display: flex;
		flex-direction: column;
		gap: 0.25rem;
	`,
	productName: css`
		font-weight: 600;
		color: #111827;
	`,
	productSubInfo: css`
		font-size: 0.875rem;
		color: #6b7280;
	`,
	priceInfo: css`
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
		min-width: 10rem;
	`,
	priceRow: css`
		display: flex;
		justify-content: space-between;
		align-items: center;
	`,
	label: css`
		color: #6b7280;
		font-size: 0.875rem;
	`,
	value: css`
		color: #111827;
		font-weight: 500;
	`,
}
